import React, { FC } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Students } from "../../../../../models/InstituteModel/students.model";
import { ArrowLeftOutlined } from "@ant-design/icons";
import CardMenu from "../../../../../shared/components/CourseComponents/CardMenu";
import "./instituteStudentDetails.scss";
import { Tabs } from "antd";
import { Details } from "./Details";
import  InstituteLeaderboard from "./Leaderboard";
import { InstituteStudentAnalytics } from "./Analytics";
const { TabPane } = Tabs;
export const InstituteStudentDetails: FC = () => {
  const { state }: { state: Students } = useLocation();
  const history = useHistory()
  return (
    <div className="page-view student-details__container">
      <div className="student-details-header__container">
        <div className="student-details-header__wrapper">
          <div className="header__left">
            <ArrowLeftOutlined onClick={() => history.goBack()}/>
            <div className="student-details__wrapper">
              <p className="student__name">{state?.name}</p>
              <p>{state?.id}</p>
            </div>
          </div>
          <div className="header__right">
            {/* <CardMenu
              menuText={"Student"}
              handleDelete={() => {}}
              handleEdit={() => {}}
            /> */}
          </div>
        </div>
      </div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Details" key="1">
          <Details/>
        </TabPane>
        <TabPane tab="Subscription" disabled key="2"></TabPane>
        <TabPane tab="Analytics" key="3" disabled>
          <InstituteStudentAnalytics/>
        </TabPane>
        <TabPane tab="Leaderboard" key="4">
          <InstituteLeaderboard/>
        </TabPane>
      </Tabs>
    </div>
  );
};
